import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { faHeart as faHeartEmpty } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartFull } from '@fortawesome/free-solid-svg-icons';
import { OpenDialogHelpComponent } from 'app/components/dialog/open-dialog-help/open-dialog-help.component';
import { OpendialogLoginComponent } from 'app/components/dialog/open-dialog-login/opendialog-login.component';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { OfferSession } from 'app/shared/models/class/session/session';
import { Tag } from 'app/shared/models/class/tags/tag';
import { WishList } from 'app/shared/models/class/wishlist/wishlist';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { ColorService } from 'app/shared/services/color/color.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { OfferFileService } from 'app/shared/services/offer-file/offer-file.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { SessionService } from 'app/shared/services/session/session.service';
import { WishlistService } from 'app/shared/services/wishlist/wishlist.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-offer-details',
  templateUrl: './offer-details.component.html',
  styleUrls: ['./offer-details.component.scss']
})
export class OfferDetailsComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() offerSub: FullOffer;

  faHeartFull = faHeartFull;
  faHeartEmpty = faHeartEmpty;

  offer: FullOffer;
  myWishes: FullOffer[];
  myShoppingBag: FullOffer[];
  userConnected: InfosUser;
  sessions: OfferSession[];
  club: ClubDetails;
  files: any;
  univerTrain = 3;
  colorsTag: any;
  tags: Tag[];
  image: any;
  carousel: any = [];
  slideIndex = 1;

  isLoadingCarousel = false;

  constructor(
    private offerService: OfferService,
    private route: ActivatedRoute,
    private dataService: DataService,
    private authService: AuthService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private sessionBasketService: SessionBasketService,
    private wishlistService: WishlistService,
    private sessionService: SessionService,
    private clubService: ClubService,
    private offerFileService: OfferFileService,
    private colorService: ColorService,
    private domSanitizer: DomSanitizer,
    private faIconService: FaiconService,
  ) {
    super();
  }


  ngOnInit(): void {
    this.initComponent();
    this.initSub();
    this.getColorTags();
    this.getOfferById();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getOfferById(): void {
    const { offerKey } = this.route.snapshot.queryParams;
    // this.getImage(+offerKey);
    this.getCarouselPictures(+offerKey);

    if (+offerKey !== undefined) {
      this.offerService.getOfferById(+offerKey).subscribe({
        next: offer => {
          this.offer = offer;
          this.tags = this.getTags(offer?.tags);
          this.getClub(offer.clubCode);
        }
      });
    } else {
      this.offer = this.offerSub;
    }
  }


  addOrDeleteToMyWish(offer: FullOffer, event): void {
    this.authService.refreshToken();
    const { offerKey } = offer;

    if (this.authService.isAuth()) {

      const { sub: userKey } = this.authService.getDecodedToken();
      const wishlistUpdate = new WishList(+userKey, []);

      this.myWishes.forEach(wish => {
        wishlistUpdate.offerKey.push(wish.offerKey);
      });

      const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offerKey);

      indexOfferInMyWishesUpdate === -1 ?
        (wishlistUpdate.offerKey.push(offerKey)) :
        (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

      this.wishlistService.updateWishList(wishlistUpdate).subscribe({
        next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
      });
    } else {
      const dialogRef = this.dialog.open(OpendialogLoginComponent);

      dialogRef.afterClosed().subscribe({
        next: () => {
          const { sub: userKey } = this.authService.getDecodedToken();
          const wishlistUpdate = new WishList(+userKey, []);

          this.myWishes.forEach(wish => {
            wishlistUpdate.offerKey.push(wish.offerKey);
          });

          const indexOfferInMyWishesUpdate = wishlistUpdate.offerKey.findIndex(o => o === offerKey);

          indexOfferInMyWishesUpdate === -1 ?
            (wishlistUpdate.offerKey.push(offerKey)) :
            (wishlistUpdate.offerKey.splice(indexOfferInMyWishesUpdate, 1));

          this.wishlistService.updateWishList(wishlistUpdate).subscribe({
            next: myWhishes => { this.dataService.myWishes.next(myWhishes); }
          });
        }
      });
    }

  }

  isInMyWishes(offerId: string): object {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? this.faHeartEmpty : this.faHeartFull;
  }

  isInMyWishesBoolean(offerId: string): boolean {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? false : true;
  }

  getColorOfHeart(offerId: string): string {
    const indexOfferInMyWhishes = this.myWishes?.findIndex(o => o.offerKey === +offerId);
    return indexOfferInMyWhishes === -1 ? '#2c296d' : '#ff0000';
  }

  addOrDeleteToMyShoppingBag(offer: FullOffer): void {
    this.authService.refreshToken();
    const { offerKey } = offer;

    if (this.authService.isAuth()) {

      const { sub: userKey } = this.authService.getDecodedToken();

      this.sessionBasketService.canAddToSessionBasket(+userKey, offerKey).subscribe({
        next: myShoppingBag => {
          this.router.navigate(['/home/my-shopping-bag']);
        }
      });

    } else {
      const dialogRef = this.dialog.open(OpendialogLoginComponent);
      dialogRef.afterClosed().subscribe({
        next: () => {
          const { sub: userKey } = this.authService.getDecodedToken();

          this.sessionBasketService.addInMyBasket(+userKey, offerKey).subscribe({
            next: myShoppingBag => {
              this.router.navigate(['/home/my-shopping-bag']);
            }
          });
        }
      });
    }
  }

  isInBasket(): boolean {
    const { offerKey } = this.route.snapshot.queryParams;
    const indexOffer = this.myShoppingBag?.findIndex(o => o.offerKey === +offerKey);
    return indexOffer === -1 ? false : true;
  }

  getNumberOfRow(): number {
    let count = 0;

    if (this.offer?.duration) {
      count++;
    }
    if (this.offer?.customerPromise) {
      count++;
    }
    if (this.offer?.informations) {
      count++;
    }
    if (this.offer?.services) {
      count++;
    }
    if (this.offer?.practicePlace) {
      count++;
    }
    if (this.offer?.environment) {
      count++;
    }
    if (this.offer?.prerequisites) {
      count++;
    }
    if (this.offer?.openingPeriod) {
      count++;
    }

    return Math.round(count / 2);
  }

  downloadFile(offerKey: number, offerFileKey: number, name: string): void {
    this.offerFileService.downloadFile(offerKey, offerFileKey).subscribe({
      next: (blob) => {

        const data = window.URL.createObjectURL(<any>blob.body);
        const anchor = document.createElement('a');
        anchor.href = data;
        anchor.download = name;
        anchor.click();

        setTimeout(() => {

          window.URL.revokeObjectURL(data);

        }, 100);
      }
    });
  }

  scrollTo(element: HTMLElement, position: HTMLElement): void {
    element.scrollTo({
      top: Math.round(this.getOffset(position).bottom),
      behavior: 'smooth'
    });
  }

  getUnivers(): boolean {

    const check = this.offer?.universes.map(u => u.universeKey);

    return check?.findIndex(u => u === this.univerTrain) !== -1 ? true : false;

  }

  getValueColorTag({ colorKey }): string {
    return '#' + this.colorsTag?.find(c => c.colorKey === colorKey)?.value;
  }

  getTags(tags: Tag[]): Tag[] {
    let tempoTag = [];

    for (let i = 1; i < this.colorsTag?.length + 1; i++) {
      const colorOrder = this.colorsTag.find(c => c.order === i);
      const tempo = tags.filter(t => t.colorKey === colorOrder.colorKey).sort((a, b) => (a.tagName.toLowerCase() as any) - (b.tagName.toLowerCase() as any));
      tempoTag = [...tempoTag, ...tempo];
    }

    return tempoTag;
  }

  getImg(): string {
    if (this.club?.logo) {
      return `data:image/png;base64,${this.club?.logo}`;
    } else {
      return '';
    }
  }

  private getImage(offerKey: number) {
    this.offerService.getImgOffer(offerKey).subscribe({
      next: image => {
        this.image = this.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64, ${image.pictureBase64}`);
      }
    });
  }

  private getCarouselPictures(offerKey: number) {
    this.isLoadingCarousel = true;
    this.offerService.getCarouselPictures(offerKey).subscribe({
      next: carousel => {
        carousel.map((image, index) => {
          this.carousel.push({
            src: this.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64, ${image}`),
            selected: index === 0 ? true : false
          })
        })

        this.showSlides(this.slideIndex);
        this.isLoadingCarousel = false;
        setInterval(() => {
          this.plusSlides(1);
        }, 6000)
      }
    });
  }

  private getColorTags(): void {
    this.colorService.getColors().subscribe({
      next: colorsTag => this.colorsTag = colorsTag
    });
  }


  private getBasketList(): void {
    const { sub: userKey } = this.authService.getDecodedToken();
    this.sessionBasketService.getBasketList(+userKey).subscribe({
      next: basketList => {
        this.myShoppingBag = basketList;
        this.dataService.myShoppingBag.next(basketList);

        this.isInBasket();

      }
    });
  }

  private getSessionByClub(): void {
    const { offerKey } = this.route.snapshot.queryParams;
    this.sessionService.getSessionByOffer(+offerKey).subscribe({
      next: sessions => {
        this.sessions = sessions.filter(s => s.isActive && s.sessionStartDate.toString() !== '0001-01-01T00:00:00Z');
      }
    });
  }

  private getClub(clubCode: string): void {
    this.clubService.getClubDetails().subscribe({
      next: clubs => {
        this.club = clubs.find(c => c.clubCode === clubCode);
      }
    });
  }

  private getFilesByOffer(): void {
    const { offerKey } = this.route.snapshot.queryParams;
    this.offerFileService.getFiles(+offerKey).subscribe({
      next: files => this.files = files.result
    });
  }

  private getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      top: rect.top + window.scrollY,
      bottom: rect.bottom + window.scrollY
    };
  }


  private initComponent(): void {
    this.dataService.tabHome$.next('other');
    this.dataService.titleHomePage.next('');
    this.userConnected = this.authService.getDecodedToken();
    if (this.userConnected) { this.getBasketList(); }
    this.getSessionByClub();
    this.getFilesByOffer();
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.myWishes.subscribe({
          next: myWishes => { this.myWishes = myWishes; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.dataService.myShoppingBag.subscribe({
          next: myShoppingBag => { this.myShoppingBag = myShoppingBag; this.cdr.detectChanges(); }
        })
      );

  }

  openDialogHelp() {
    this.dialog.open(OpenDialogHelpComponent, {
      data: { helpVideoKey: 2 },
      width: '60%',
      maxHeight: '90%'
    });
  }

  plusSlides(n) {
    this.showSlides(this.slideIndex += n);
  }

  currentSlide(n) {
    this.showSlides(this.slideIndex = n);
  }

  showSlides(n) {
    let i;
    let slides = this.carousel;

    if (n > slides.length) { this.slideIndex = 1 }
    if (n < 1) { this.slideIndex = slides.length }
    for (i = 0; i < slides.length; i++) {
      slides[i].selected = false;
    }

    slides[this.slideIndex - 1].selected = true;
  }

}
